<template lang="pug">
nav.network-wrapper(:class="networkWrapperClasses")
  .network
    FontAwesomeIcon.icon(:icon='$icons.wifi' slot='extra')
    p {{ network.message }}
</template>

<script>
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import "./scss";
import { Events } from "@timesheets/webapp-support";
import { NetworkStatus } from "@timesheets/constants-common";

export default {
  name: "NetworkStatus",
  data() {
    return {
      inErrorState: false,
      network: {
        status: this.$Constants.NetworkStatus.Online,
        message: "Connection to the network lost",
      },
    };
  },
  computed: {
    networkWrapperClasses() {
      const classes = [this.network.status];
      if (this.network.status === this.$Constants.NetworkStatus.Online) {
        classes.push("hide");
      }

      return classes;
    },
  },
  created() {
    WebApplicationConstants.listenerEventBuses.system.on(this.$Events.SystemErrorEvent.Type, () => (this.inErrorState = true), this);
    WebApplicationConstants.listenerEventBuses.system.on(Events.NetworkStatusChangedEvent.Type, this.networkStatusChanged, this);
  },
  methods: {
    networkStatusChanged(event) {
      this.network = event.data;
      if (this.network.status === NetworkStatus.Online && this.inErrorState && this.$app.instance !== "local") {
        window.location.reload();
      }
    },
  },
};
</script>
